import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { useAuthorSuggestions } from '@/hooks/useAuthorSuggestions';
import { FollowAuthorButton } from './FollowAuthorButton';
import { Skeleton } from '@/components/ui/skeleton';
import { UserPlus } from 'lucide-react';
import { Link } from 'react-router-dom';

export function AuthorFollowSuggestions() {
  const { data: suggestions = [], isLoading } = useAuthorSuggestions();

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-64" />
        </CardHeader>
        <CardContent>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {[1, 2, 3].map(i => (
              <Skeleton key={i} className="h-32 w-full" />
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  if (suggestions.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <UserPlus className="h-5 w-5" />
          Authors You Might Love
        </CardTitle>
        <CardDescription>
          Get notified when these authors you've enjoyed release new books
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {suggestions.map((suggestion) => (
            <Card key={suggestion.authorNameNormalized} className="overflow-hidden">
              <CardContent className="p-4">
                <div className="space-y-3">
                  <div>
                    <Link 
                      to={`/author/${encodeURIComponent(suggestion.authorName)}`}
                      className="font-semibold hover:text-primary transition-colors"
                    >
                      {suggestion.authorName}
                    </Link>
                    <p className="text-sm text-muted-foreground mt-1">
                      {suggestion.reason}
                    </p>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="text-xs text-muted-foreground">
                      {suggestion.bookCount} books · {suggestion.averageRating}★ avg
                    </div>
                    <FollowAuthorButton 
                      authorName={suggestion.authorName}
                      size="sm"
                      showText={false}
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
